export { default } from './FeaturedProjectsSection';
